/* Greenic Newsletter mit Stufen (Stand 15.10.2026, Vorschau B nl_block.py und nlf_block.py). Markup: snippets/gx-newsletter.liquid.
   Zwei Rahmen: Sheet auf der Produktseite (geöffnet von .gxnl-open im Block addons) und Footer-Block (sections/footer.liquid).
   Absenden per fetch an die Klaviyo Client Subscriptions API: POST https://a.klaviyo.com/client/subscriptions/?company_id=<id>,
   Header revision 2025-07-15, Content-Type application/vnd.api+json, Body mit E-Mail, properties.willkommen_stufe als Zahl
   (5, 10 oder 15), Einwilligung SUBSCRIBED, custom_source je Rahmen und der Liste. Antwort 202 ohne Inhalt, dann Danke-Zustand
   ohne Neuladen. Fehler: Hinweis im Formular, nichts geht verloren. Die Datei kann zweimal eingebunden sein (Sheet und Footer),
   sie läuft nur einmal. */
(function () {
  'use strict';
  if (window.__gxNl) return;
  window.__gxNl = true;
  var doc = document;
  var REVISION = '2025-07-15';

  function pct(form) { var r = form.querySelector('input[type=radio]:checked'); return r ? r.value : '10'; }

  /* Sheet: öffnen, schließen, Seite sperren (gleiche Body-Klasse wie Teilen und Frag uns in greenic-pdp.js) */
  var lastTrigger = null;
  function lock(on) {
    var any = on || !!doc.querySelector('.gxsheet.is-open');
    doc.body.classList.toggle('gxsheet-open', any);
  }
  function openSheet(root, trigger) {
    if (!root || root.classList.contains('is-open')) return;
    lastTrigger = trigger || null;
    if (root.__gxReset) root.__gxReset(true);
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    lock(true);
    var f = root.querySelector('[data-gx-nl-email]');
    setTimeout(function () { if (f && root.classList.contains('is-open')) try { f.focus({ preventScroll: true }); } catch (e) {} }, 420);
  }
  function closeSheet(root) {
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    lock(false);
    if (lastTrigger && lastTrigger.focus) try { lastTrigger.focus({ preventScroll: true }); } catch (e) {}
    lastTrigger = null;
  }

  function init(root) {
    if (root.__gxNlInit) return;
    var form = root.querySelector('[data-gx-nl-form]');
    if (!form) return;
    root.__gxNlInit = true;
    var done = root.querySelector('.gxnl__done'), head = root.querySelector('.gxnl__head'), err = root.querySelector('.gxnl__error');
    var sendPct = form.querySelector('.gxnl__send-pct'), donePct = done ? done.querySelector('.gxnl__done-pct') : null;
    var btn = form.querySelector('.gxnl__send'), email = form.querySelector('[data-gx-nl-email]');
    var isSheet = root.classList.contains('gxsheet');
    var busy = false;

    function sync() { if (sendPct) sendPct.textContent = pct(form) + '%'; }
    form.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio') sync(); });
    sync();

    root.__gxReset = function (clear) {
      if (busy) return;
      if (clear) { form.reset(); sync(); }
      form.hidden = false;
      if (done) done.hidden = true;
      if (head) head.hidden = false;
      if (err) err.hidden = true;
      root.classList.remove('is-done');
    };

    if (isSheet) {
      /* an den body hängen: fixed bleibt am Bildschirm, auch wenn ein Vorfahr transform oder filter trägt;
         eine ältere Kopie aus dem Theme-Editor (Section neu geladen) vorher entfernen */
      [].forEach.call(doc.querySelectorAll('body > .gxnl-clip'), function (o) { if (o !== root && o.id === root.id) o.parentNode.removeChild(o); });
      if (root.parentNode !== doc.body) doc.body.appendChild(root);
      [].forEach.call(root.querySelectorAll('[data-gxnl-close]'), function (b) { b.addEventListener('click', function () { closeSheet(root); }); });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (err) err.hidden = true;
      if (!form.reportValidity()) return;
      var adr = (email.value || '').trim(), stufe = Number(pct(form));
      var company = form.getAttribute('data-company'), list = form.getAttribute('data-list');
      if (!adr || !company || !list) { if (err) err.hidden = false; return; }
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.getAttribute('data-source') || 'Newsletter',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: adr,
                  properties: { willkommen_stufe: stufe },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      };
      busy = true;
      if (btn) btn.disabled = true;
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!(r.status === 202 || r.ok)) throw new Error('Klaviyo ' + r.status);
        if (donePct) donePct.textContent = stufe + '%';
        form.hidden = true;
        if (head) head.hidden = true;
        if (done) done.hidden = false;
        root.classList.add('is-done');
        var ghost = done ? done.querySelector('[data-gxnl-close]') : null;
        if (ghost) try { ghost.focus({ preventScroll: true }); } catch (x) {}
      }).catch(function () {
        if (err) err.hidden = false;
      }).then(function () {
        busy = false;
        if (btn) btn.disabled = false;
      });
    });
  }

  function scan() { [].forEach.call(doc.querySelectorAll('[data-gx-nl]'), init); }

  /* Ein Klick-Handler für alle Newsletter-Buttons (auch nach Neuladen einer Section im Theme-Editor) */
  doc.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.gxnl-open') : null;
    if (!t) return;
    var root = doc.querySelector('.gxnl-clip[data-gx-nl]');
    if (!root) return;
    e.preventDefault();
    init(root);
    openSheet(root, t);
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var root = doc.querySelector('.gxnl-clip.is-open');
    if (root) closeSheet(root);
  });

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', scan); else scan();
  doc.addEventListener('shopify:section:load', scan);
})();
